import { parseJSON } from './parseJSON';
import { stringifyJSON } from './stringifyJSON';

export function copyJson<T>(value: T): T {
	// Convert type because it should be safe to assume that we'll get back the original type when doing a combination of stringify + parse
	return parseJSON(stringifyJSON(value)) as T;
}
